/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmbassadorPurchaseSessionResponse } from '../../models/ambassador-purchase-session-response';

export interface CreateGoldAmbassadorPurchaseSession$Params {
}

export function createGoldAmbassadorPurchaseSession(http: HttpClient, rootUrl: string, params?: CreateGoldAmbassadorPurchaseSession$Params, context?: HttpContext): Observable<StrictHttpResponse<AmbassadorPurchaseSessionResponse>> {
  const rb = new RequestBuilder(rootUrl, createGoldAmbassadorPurchaseSession.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmbassadorPurchaseSessionResponse>;
    })
  );
}

createGoldAmbassadorPurchaseSession.PATH = '/api/company/checkout-gold-ambassador-services';
